import { Box } from '@factorialco/deprecated-design-system'

import { BlockingIssues } from 'modules/integrations/components/SyncFooter/BlockingIssues'
import { IntegrationSettingsLink } from 'modules/integrations/components/SyncFooter/IntegrationSettingsLink'
import { LastSync } from 'modules/integrations/components/SyncFooter/LastSync'
import { useIntegrationsSyncContext } from 'modules/integrations/hooks/SyncContext'

export const SyncFooter = () => {
  const { syncEnabled } = useIntegrationsSyncContext()

  if (!syncEnabled) return null

  return (
    <Box
      paddingTop="s8"
      paddingBottom="s2"
      paddingX="s24"
      background="darker040"
      style={{
        position: 'relative',
        left: '-24px',
        marginTop: '-17px',
        zIndex: '10',
        borderBottomLeftRadius: '14px',
        borderBottomRightRadius: '14px',
        alignItems: 'flexStart',
        flexDirection: 'row',
        gap: '8px',
      }}
    >
      <LastSync />
      <BlockingIssues />
      <IntegrationSettingsLink />
    </Box>
  )
}
